import type { EmailEventPreview } from "@shared/emailCalendar";
import { Button } from "@web/ui/Button";
export function eventTimeLabel(instant: string, zone: string): string {
  return new Intl.DateTimeFormat(undefined, {
    timeZone: zone,
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  }).format(new Date(instant));
}
export function EventReview({
  preview,
  endInclusive,
  busy,
  problem,
  onConfirm,
  onBack,
  onClose,
}: {
  preview: EmailEventPreview;
  endInclusive: string;
  busy: boolean;
  problem: string;
  onConfirm: () => void;
  onBack: () => void;
  onClose: () => void;
}) {
  return (
    <div className="flex flex-col gap-4 p-5">
      <h2 className="text-2xl">Review calendar event</h2>
      <p className="text-sm text-muted">
        Google Calendar · {preview.accountEmail} · {preview.calendarName}
      </p>
      <h3 className="text-xl break-words">{preview.input.title}</h3>
      <p className="text-sm">
        {preview.input.allDay
          ? `${preview.input.startLocal} through ${endInclusive} · All day`
          : `${eventTimeLabel(preview.start, preview.input.startTimeZone)} → ${eventTimeLabel(preview.end, preview.input.endTimeZone)}`}
      </p>
      <p className="text-sm">
        Location: {preview.input.location || "None"}
        <br />
        Reminder:{" "}
        {preview.input.reminderMinutes === null
          ? "None"
          : `${preview.input.reminderMinutes} minutes before`}
      </p>
      <pre className="max-h-40 overflow-auto rounded-lg bg-bg p-3 font-sans text-sm whitespace-pre-wrap break-words">
        {preview.description}
      </pre>
      <p className="text-sm text-muted">
        Private event, no guests or invitations. This copies the details; it doesn’t RSVP, book a
        flight, or track later schedule changes.
      </p>
      {preview.warnings.map((w) => (
        <p className="text-sm text-note-ink" key={w}>
          {w}
        </p>
      ))}
      {problem ? (
        <p role="alert" className="text-sm">
          {problem}
        </p>
      ) : null}
      <div className="sticky -bottom-5 -mx-5 flex flex-wrap gap-2 border-t border-line bg-paper px-5 py-3">
        <Button variant="primary" busy={busy} onClick={onConfirm}>
          Confirm: add to calendar
        </Button>
        <Button disabled={busy} onClick={onBack}>
          Edit details
        </Button>
        <Button variant="ghost" disabled={busy} onClick={onClose}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
